import { getAgentFromStorage, serialize } from '@/utils/appUtils'
import DataApiUtil from '@/utils/dataApiUtils'

export interface AgentStatisticsRow {
  _id: string
  updated_at: string
  name: string
  user_count: number
  persona: string
  document_count: number
  quiz_count: number
  roleplay_count: number
}

export interface AgentStatisticsData {
  rows: AgentStatisticsRow[]
  pagination: {
    page: number
    page_size: number
    total_items: number
    total_pages: number
  }
}

export interface AgentUsageStatisticsRow {
  _id: string
  name: string
  question_count: number
  answered_question_count: number
  quiz_submission_count: number
  roleplay_submission_count: number
  active_user_count: number
  returning_user_count: number
}

export interface AgentUsageStatisticsData {
  rows: AgentUsageStatisticsRow[]
  pagination: {
    page: number
    page_size: number
    total_items: number
    total_pages: number
  }
}

export const getActiveUserOrganisationReports = async (
  filtersData: any,
): Promise<any> => {
  const copiedFilter = { ...filtersData }
  delete copiedFilter.type
  const res = await DataApiUtil.SendAsync<any>({
    url: `/report/report-data/org-active-users-sessions?${serialize(
      copiedFilter,
    )}&agent_id=${getAgentFromStorage()}`,
    method: 'GET',
  })
  return res
}

export const getWeeklyActiveUserOrganisationReports = async (
  filtersData: any,
): Promise<any> => {
  const copiedFilter = { ...filtersData }
  delete copiedFilter.type
  const res = await DataApiUtil.SendAsync<any>({
    url: `/report/report-data/org-weekly-active-users-sessions?${serialize(
      copiedFilter,
    )}&agent_id=${getAgentFromStorage()}`,
    method: 'GET',
  })
  return res
}

export const getOrganisationOverview = async (
  filtersData: any,
): Promise<{
  agent_count: number
  admin_count: number
  user_count: number
  active_user_count: number
  quiz_submission_count: number
  roleplay_submission_count: number
  question_count: number
  answered_question_count: number
}> => {
  const copiedFilter = { ...filtersData }
  delete copiedFilter.type
  const res = await DataApiUtil.SendAsync<any>({
    url: `/report/report-data/org-overview?${serialize(
      copiedFilter,
    )}&agent_id=${getAgentFromStorage()}`,
    method: 'GET',
  })

  if (res.status !== 200) {
    console.error('Error fetching organisation overview:', res)
    return {
      answered_question_count: 0,
      quiz_submission_count: 0,
      roleplay_submission_count: 0,
      agent_count: 0,
      question_count: 0,
      admin_count: 0,
      user_count: 0,
      active_user_count: 0,
    }
  }
  return res?.data?.data?.report_data?.rows?.[0]
}

export const getAgentStatistics = async (
  filtersData: any,
): Promise<AgentStatisticsData> => {
  const copiedFilter = { ...filtersData }
  delete copiedFilter.type

  const paginationQuery = copiedFilter.page
    ? `page=${copiedFilter.page}&page_size=${copiedFilter.page_size}&`
    : ''
  delete copiedFilter.page
  delete copiedFilter.page_size

  const sortQuery = copiedFilter.sort ? `sort=${copiedFilter.sort}&` : ''
  delete copiedFilter.sort

  const res = await DataApiUtil.SendAsync<any>({
    url: `/report/report-data/org-agent-statistics?${serialize(
      copiedFilter,
    )}&${paginationQuery}${sortQuery}agent_id=${getAgentFromStorage()}`,
    method: 'GET',
  })
  if (res.status !== 200) {
    console.error('Error fetching agent statistics:', res)
    return {
      rows: [],
      pagination: {
        page: 1,
        page_size: 25,
        total_items: 0,
        total_pages: 0,
      },
    }
  }
  return res?.data?.data?.report_data
}

export const getAgentUsageStatistics = async (
  filtersData: any,
): Promise<AgentUsageStatisticsData> => {
  const copiedFilter = { ...filtersData }
  delete copiedFilter.type

  const paginationQuery = copiedFilter.page
    ? `page=${copiedFilter.page}&page_size=${copiedFilter.page_size}&`
    : ''
  delete copiedFilter.page
  delete copiedFilter.page_size

  const sortQuery = copiedFilter.sort ? `sort=${copiedFilter.sort}&` : ''
  delete copiedFilter.sort

  const res = await DataApiUtil.SendAsync<any>({
    url: `/report/report-data/org-agent-usage?${serialize(
      copiedFilter,
    )}&${paginationQuery}${sortQuery}agent_id=${getAgentFromStorage()}`,
    method: 'GET',
  })
  if (res.status !== 200) {
    console.error('Error fetching agent usage statistics:', res)
    return {
      rows: [],
      pagination: {
        page: 1,
        page_size: 25,
        total_items: 0,
        total_pages: 0,
      },
    }
  }
  return res?.data?.data?.report_data
}
